export var START_PHOTO_REPOSITION = 'START_PHOTO_REPOSITION';
export var CANCEL_PHOTO_REPOSITION = 'CANCEL_PHOTO_REPOSITION';
